'use client'

import ErrorMessage from '@components/ErrorMessage'
import { memo, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Holding } from '@hooks/useHoldings'
import NavigationButtonGroup from '@components/NavigationButtonGroup'
import RewardsSection from './RewardsSection'
import DashboardSection from './DashboardSection'

type HoldingDetailsProps = {
  mint: string
  holdings: Holding[]
  ripple?: boolean
  referral?: boolean
}

const NAV_TABS = ['Dashboard', 'Rewards'] as const

function HoldingDetails({
  ripple,
  referral,
  mint,
  holdings,
}: HoldingDetailsProps) {
  const { t } = useTranslation()

  const [activeRoute, setActiveRoute] = useState<string>(NAV_TABS[0])

  // TODO: Why are all holdings being passed into the holding details? @Salvador
  const holding = useMemo(
    () => holdings.find((holding) => holding.publicKey.toBase58() === mint),
    [holdings, mint],
  )

  const onSelect = (route: string) => {
    setActiveRoute(route)
  }

  const navRoutes = useMemo(() => {
    return NAV_TABS.map((tab) => ({
      name: tab,
      isNav: false,
    }))
  }, [])

  return (
    <div className="flex flex-col w-full gap-2 mt-20">
      {holding ? (
        <>
          <div className="w-full flex justify-center">
            <NavigationButtonGroup
              routes={navRoutes}
              onClick={onSelect}
              selected={activeRoute}
            />
          </div>
          {activeRoute === NAV_TABS[0] && (
            <DashboardSection ripple={ripple} holding={holding} />
          )}
          {activeRoute === NAV_TABS[1] && <RewardsSection holding={holding} />}
        </>
      ) : (
        <ErrorMessage text={t('holdings.details.tokenNotFound')} />
      )}
    </div>
  )
}

export default memo(HoldingDetails)
